import React from 'react';
import { Pricing } from './components/Pricing';

const PricingApp = props => <Pricing {...props} />;

export default PricingApp;
